import React from "react";
import { MdClose } from "react-icons/md";

import ContainedButton from "components/layout/form/containedButton";

import {
  Alert,
  Container,
  ContainerButtons,
  ModalHeader,
  ModalStyle,
} from "./styles";

interface IDebitSuccessModal {
  openModal: boolean;
  modalFunction: React.Dispatch<React.SetStateAction<boolean>>;
  text?: string;
}

const DebitSuccessModal = ({
  openModal,
  modalFunction,
  text,
}: IDebitSuccessModal): JSX.Element => {
  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
        <span>Débito automático</span>
        <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        <Alert dangerouslySetInnerHTML={{ __html: text }} />
        <ContainerButtons>
          <ContainedButton block onClick={() => modalFunction(false)}>
            OK
          </ContainedButton>
        </ContainerButtons>
      </Container>
    </ModalStyle>
  );
};

export default DebitSuccessModal;
